/**
 * MessageStatus Component
 * Displays WhatsApp-style message delivery status indicators
 */

import React from 'react';
import {
  LoadingOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import type { MessageStatus as Status } from '@/api/types/chat.types';
import './MessageStatus.css';

interface MessageStatusProps {
  status?: Status;
  onRetry?: () => void;
}

export const MessageStatus: React.FC<MessageStatusProps> = ({
  status,
  onRetry,
}) => {
  if (!status) return null;

  switch (status) {
    case 'sending':
      return (
        <span
          className="message-status message-status-sending"
          title="Sending..."
        >
          <LoadingOutlined spin />
        </span>
      );

    case 'sent':
      return (
        <span
          className="message-status message-status-sent"
          title="Sent to server"
        >
          <CheckOutlined />
        </span>
      );

    case 'delivered':
      return (
        <span
          className="message-status message-status-delivered"
          title="Delivered via WebSocket"
        >
          <CheckOutlined />
          <CheckOutlined className="message-status-second-check" />
        </span>
      );

    case 'failed':
      return (
        <span
          className="message-status message-status-failed"
          title={
            onRetry ? 'Failed to send. Click to retry.' : 'Failed to send.'
          }
          onClick={onRetry}
          style={{ cursor: onRetry ? 'pointer' : 'default' }}
        >
          <ExclamationCircleOutlined />
        </span>
      );

    default:
      return null;
  }
};
